module.exports = __webpack_public_path__ + "static/media/airplane.b60a8e5c.svg";